import { styled, component } from '../../../utils/style';
import { StyleColor } from '../../../utils/styles-constants';

export const StyledDriveItemRow = styled()(component.div, 'StyledDriveItemRow')`
	display: flex;
	background-color: ${StyleColor.White};
`;

interface BackgroundImageProps {
	src: string;
}

export const BackgroundImage = styled<BackgroundImageProps>()(component.div, 'BackgroundImage')`
	height: 120px;
	width: 120px;
	flex-shrink: 0;
	background-image: url("${props => props.src}");
	background-size: cover;
    background-position: 50% 50%;
`;

export const SvgWrapper = styled()(component.span, 'SvgWrapper')`
	> svg {
		height: 100px;
		width: 100px;
		fill: ${StyleColor.Grey500};
		margin: 10px 10px 6px 10px;
	}
`;

export const ItemInfos = styled()(component.div, 'ItemInfos')`
	align-items: center;
	display: flex;
	padding-left: 20px;
	padding-right: 15px;
	flex-grow: 1;
	width: calc(100% - 160px);
	background-color: ${props => props.theme.primary.cardColor};
	color: ${props => props.theme.primary.contentColor};
	`;

export const ItemLabel = styled()(component.span, 'ItemLabel')`
	font-size: 15px;
	font-weight: 500;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	flex-grow: 1;
`;

export const ImageWrapper = styled()(component.span, 'Favorite')`
	height: 120px;
`;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DriveItem/Row/styles.ts